import { hasInvitationQueryParameter } from './hasInvitationQueryParameter'

export function showSignUp(searchParams) {
  if (hasInvitationQueryParameter(searchParams)) {
    if (searchParams.has('mode')) {
      return searchParams.get('mode') === 'signup'
    } else {
      return true
    }
  } else {
    return false
  }
}
